import React from 'react'
import moment from 'moment'
import { component_tool } from '@/tool'
let { WizDataTable, WizButton, WizModal } = component_tool

let componentName = 'featured'

const columns = self => {
  return [
    {
      title: '关联内容',
      name: 'entityName',
      dataIndex: 'entityName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '关联类型',
      name: 'entityType',
      dataIndex: 'entityType',
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 2, codeName: '问卷' },
        // { code: 3, codeName: '直播' },
        { code: 15, codeName: '报名' },
        { code: 20, codeName: '公告' },
        // { code: 22, codeName: '话题' },
        // { code: 23, codeName: '活动' },
        { code: 25, codeName: '系列化课程'},
        { code: 26, codeName: '直播' },
        { code: 12, codeName: '培训路径' },
        { code: 59, codeName: '练习'},
        // { code: 37, codeName: '投票' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {}
    },
    {
      title: '发布平台',
      name: 'platforms',
      dataIndex: 'platforms',
      dict: [
        { code: 0, codeName: 'PC' },
        { code: 1, codeName: 'APP' },
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {
        type: 'checkbox'
      }
    },
    {
      title: '推荐位',
      name: 'positions',
      dataIndex: 'positions',
      dict: [
        { code: 0, codeName: '首页轮播' },
        { code: 1, codeName: '广告位' },
        { code: 2, codeName: '路径推荐位' },
        { code: 3, codeName: '任务推荐位' }
      ],
      tableItem: {
        type: 'checkbox'
      }
    },
    {
      title: '状态',
      name: 'state',
      dataIndex: 'state',
      dict: [
        { code: 0, codeName: '草稿' },
        { code: 1, codeName: '打开' },
        { code: 2, codeName: '关闭' },
        { code: 3, codeName: '失效' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {}
    },
    {
      title: '推荐位',
      name: 'positions',
      dataIndex: 'positions',
      dict: [
        { code: 0, codeName: '首页轮播' },
        { code: 1, codeName: '广告位' },
        { code: 2, codeName: '路径推荐位' },
        { code: 3, codeName: '任务推荐位' }
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: '生效时间',
      name: 'time',
      dataIndex: 'time',
      searchItem: {
        type: 'date~'
      }
    },
    {
      title: '生效时间',
      name: 'startDate',
      dataIndex: 'startDate',
      tableItem: {}
    },
    {
      title: '失效时间',
      name: 'endDate',
      dataIndex: 'endDate',
      tableItem: {}
    },
    {
      title: '更新时间',
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {}
    }
  ]
}

const templateConfig = self => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(self),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.time && value.time.length === 2) {
              value.startDate = moment(value.time[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endDate = moment(value.time[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            // delete value.time
            return value
          },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/featured/management/featuredAdd'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update', 'look', 'open', 'close'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: { children: '编辑' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/featured/management/featuredUpd'
              }
            }
          },
          {
            key: 'look',
            custom: true,
            params: { children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/featured/management/featuredLook'
              }
            }
          },
          {
            key: 'open',
            custom: true,
            params: { children: '打开'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'updateState',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                WizModal.confirm({
                  title: '注意',
                  content: '您确定要打开该推荐吗？',
                  onOk: () => {
                    callback && callback({ state: 1, id: record.id, startDate: record.startDate, endDate: record.endDate })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return { disabled: record.state === 1 }
            }
          },
          {
            key: 'close',
            custom: true,
            params: { children: '关闭' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'updateState',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                WizModal.confirm({
                  title: '注意',
                  content: '您确定要关闭该推荐吗？',
                  onOk: () => {
                    callback && callback({ state: 2, id: record.id, startDate: record.startDate, endDate: record.endDate })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return { disabled: record.state === 2 }
            }
          }
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
